module.exports = __webpack_public_path__ + "img/SKTC_stop.c75b692d.jpg";